import { useParams } from 'react-router-dom';
import keys from './keys';
import useApiQuery from '../useApiQuery';
import { useGetShow } from '../show';

const refetchEpisodes = (episodes) => {
  if (!episodes || !Array.isArray(episodes)) {
    return false;
  } else {
    return 5000;
  }
};

const useGetEpisodes = ({ showId: showIdParam, disabled, fields, importRefresh = false } = {}) => {
  const { showId: currentShowId } = useParams();
  const showId = showIdParam || currentShowId;
  const queryParams = fields || defaultFieldsParams;

  const { show, isShowLoading } = useGetShow({
    showId,
    disabled: !showId || disabled || !importRefresh,
    importRefresh: true,
  });

  const isWithRefresh = importRefresh && show?.status === 'processing';

  const query = useApiQuery({
    queryKey: keys(showId).episodes,
    requestUrl: `/shows/${showId}/episodes?fields=${queryParams}`,
    disabled: !showId || disabled || isShowLoading,
    refetchInterval: isWithRefresh ? refetchEpisodes : null,
    refetchOnMount: isWithRefresh ? refetchEpisodes : null,
  });

  return {
    episodes: query.data,
    hasPublishedEpisodes: query.data?.some((episode) => episode?.status === 'published'),
    episodesError: query.error,
    isEpisodesFetchError: query.isError,
    isEpisodesFetchSuccess: query.isSuccess,
    isEpisodesFetching: query.isFetching,
    isEpisodesLoading: query.isInitialLoading || isShowLoading,
    ...query,
  };
};

const EPISODE_FETCH_QUERY = `show 
title 
subtitle 
cover 
status 
creationDate 
publishDate 
season 
episodeNumber 
integrations.acastPlus.tiers 
integrations.public.tiers
integrations.customPaywall.locked
encoding 
markers 
enableMonetization 
duration 
episodeId 
lastEditedDate 
publishSequence
publicIntro
publicOutro
privateIntro
privateOutro
type
import
isImported
`;

export const defaultFieldsParams = encodeURIComponent(EPISODE_FETCH_QUERY);

export default useGetEpisodes;
